// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".highlighting_category[data-v-68a85d58] :hover{color:#59afff;cursor:pointer}", ""]);
// Exports
module.exports = exports;
